import React from "react";
import { Alert, AlertTitle, Box } from "@mui/material";
import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import { useTranslation } from "react-i18next";

/**
 * Banner de mantenimiento para servicios de Inteligencia Artificial.
 *
 * Se muestra en el Main (dashboards) y en los módulos que consumen IA
 * (Coding Opportunities, Clinical Notes AI, Care Plan Generator, etc.)
 * mientras se migra la API key al backend por normativa de OpenAI.
 */
const AiMaintenanceBanner = ({ sx = {} }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ mb: 2, ...sx }}>
      <Alert
        severity="warning"
        variant="filled"
        icon={<BuildCircleIcon fontSize="inherit" />}
        sx={{
          borderRadius: 2,
          boxShadow: 2,
          "& .MuiAlert-message": { width: "100%" },
        }}
      >
        <AlertTitle sx={{ fontWeight: 700 }}>
          {t("aiMaintenance.title")}
        </AlertTitle>
        {t("aiMaintenance.message")}
      </Alert>
    </Box>
  );
};

export default AiMaintenanceBanner;
